import React from 'react';

const NoData = ({ message = '데이터 없음' }) => {
    return (
        <div className="flex items-center justify-center h-60 bg-gray-50 p-4">
            <p className="text-lg text-center" style={{ color: 'gray' }}>
                {message}
            </p>
        </div>
    );
};

export default NoData;
